<template>
  <div>
    <v-btn
      @click="onStart(0)"
      :disabled="data.Records[0].started_on != ''"
      block
      :style="'font-size:40px;letter-spacing:30px;'"
      color="success"
      height="100"
    >
      開始
    </v-btn>
    <div class="my-4 ml-4">作業時間：{{ workTime(0) }}</div>
    <v-btn
      @click="onFinish(0)"
      :disabled="
        data.Records[0].finished_on != '' || data.Records[0].started_on == ''
      "
      block
      :style="'font-size:40px;letter-spacing:30px;'"
      color="error"
      height="100"
    >
      終了
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    record: Object,
    init: String,
  },
  data() {
    return {
      data: {
        Page_id: 0,
        Report_id: null,
        Records: [
          {
            value: "",
            form_id: 0,
            form_type: 12,
            started_on: "",
            finished_on: "",
          },
        ],
      },
      uploadfile: {
        file: {},
        url: "",
        data: { name: "", size: 0, type: "" },
      },
      rules: { required: (value) => !!value || "必須項目です" },
    };
  },
  async mounted() {
    //初期処理
  },
  methods: {
    onStart(index) {
      let date = this.currentDateTime();
      this.data.Records[index].started_on = date;
      this.data.Records[index].value = date;
    },
    onFinish(index) {
      let date = this.currentDateTime();
      this.data.Records[index].finished_on = date;
      this.data.Records[index].value += "," + date;
    },
    currentDateTime() {
      let date = new Date();
      let years = date.getFullYear().toString();
      let month = (date.getMonth() + 1).toString().padStart(2, "0");
      let days = date
        .getDate()
        .toString()
        .padStart(2, "0");
      let hours = date
        .getHours()
        .toString()
        .padStart(2, "0");
      let minutes = date
        .getMinutes()
        .toString()
        .padStart(2, "0");
      let seconds = date
        .getSeconds()
        .toString()
        .padStart(2, "0");
      return (
        years +
        "-" +
        month +
        "-" +
        days +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds
      );
    },
  },
  computed: {
    workTime() {
      return function(index) {
        if (
          this.data.Records[index].started_on != "" &&
          this.data.Records[index].finished_on != ""
        ) {
          let millisecond =
            Date.parse(this.data.Records[index].finished_on) -
            Date.parse(this.data.Records[index].started_on);
          let seconds = Math.floor(millisecond / 1000);
          var hours = Math.floor(seconds / 60 / 60);
          var minutes = Math.floor(seconds / 60 - hours * 60);
          seconds = Math.floor(seconds - hours * 60 * 60 - minutes * 60);
          if (hours < 10) hours = "0" + hours;
          if (minutes < 10) minutes = "0" + minutes;
          if (seconds < 10) seconds = "0" + seconds;
          return hours + ":" + minutes + ":" + seconds;
        } else {
          return "00:00:00";
        }
      };
    },
  },
};
</script>

<style></style>
